import { render } from "./DepartmentIdeaChart.vue?vue&type=template&id=3caee78b"
import script from "./DepartmentIdeaChart.vue?vue&type=script&lang=js"
export * from "./DepartmentIdeaChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__